export enum StepType {
    previous = 1,
    next = 2
}
